import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { alertActions, authActions } from "_store";
import { useRef } from "react";
import { ERR_MSG } from "constants/labels";

const PublicRoute = ({ isAuthenticated = false, isInitialized = false }) => {
  const dispatch = useDispatch();
  const hasRanOnce = useRef(false);

  useEffect(() => {
    if (!hasRanOnce.current) {
      hasRanOnce.current = true;
      try {
        if (isAuthenticated && isInitialized) {
          dispatch(authActions.logout()).unwrap();
        }
      } catch (error) {
        dispatch(
          alertActions.error({
            header: "Log out Failed",
            message: error.message ? ERR_MSG["073"] : error,
          }),
        );
      }
    }
  }, [isAuthenticated, isInitialized, dispatch]);

  return <Outlet />;
};

export default PublicRoute;
